var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("swb-comn-seller-contract-list", {
    ref: "swb_comn_seller_contract_list",
    attrs: {
      contractType: _vm.contractType,
      merchant: _vm.merchant,
      path: _vm.path,
      thisPath: _vm.thisPath
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1bff45e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bff45e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ServcPurchContractList.vue
// module id = 2079
// module chunks = 1